import naja from "naja";

export default function (html) {
	const messagesGenerating = html.querySelector('#messagesGenerating')

	if (messagesGenerating) {
		showMessagesGeneratingProgress(html, messagesGenerating)
	}

	const tester = html.querySelector('#tester')
	tester.querySelectorAll('form input[name=roamer]').forEach((el) => {
		el.addEventListener('change', (e) => {
			onChange(tester)
		})
	})

	tester.querySelectorAll('form input[name=selection]').forEach((el) => {
		el.addEventListener('change', (e) => {
			onChange(tester)
		})
	})

	tester.querySelector('select[name=serviceProvider]').addEventListener('change', (e) => {
		let url = e.currentTarget.dataset.update
		if (url) {
			url += `&svcId=${e.currentTarget.value}`
			window.location.href = url
		}
	})

	onChange(tester)

	const message = document.querySelector('aside.mobile-screen .message .message-text')
	if (message) {
		message.innerHTML = message.innerHTML.replaceAll('<br>', '<span class="return-symbol">&#x23CE;</span><br>')
	}
}

function onChange(tester) {
	const roamer = tester.querySelector('form input[name=roamer]:checked')
	const selection = tester.querySelector('form input[name=selection]:checked')

	const selectionRow = tester.querySelector('form input[name=selection]').closest('.row')
	const msisdnRow = tester.querySelector('form input[name=msisdn]').closest('.row')
	const customerParameters = tester.querySelectorAll('form [data-customer-parameter]')
	const serviceProviderRow = tester.querySelector('select[name=serviceProvider]').closest('.row')
	const originator = tester.querySelector('select[name=originator]').closest('.row')


	selectionRow.classList.add('d-none')
	msisdnRow.classList.add('d-none')
	customerParameters.forEach((el) => {
		el.closest('.row').classList.add('d-none')
	})

	serviceProviderRow.classList.add('d-none')
	originator.classList.add('d-none')

	if (roamer) {
		if (roamer.value === "0") {
			selectionRow.classList.remove('d-none')
			serviceProviderRow.classList.remove('d-none')
			originator.classList.remove('d-none')

			if (selection.value === "0") {
				customerParameters.forEach((el) => {
					el.closest('.row').classList.remove('d-none')
				})
			} else {
				msisdnRow.classList.remove('d-none')
			}
		}
	}
}

function showMessagesGeneratingProgress(html, messagesGenerating) {
	let val = 0
	const progress = messagesGenerating.querySelector('.progress')
	const tester = html.querySelector('#tester')
	const publish = html.querySelector('#publish')
	const testTemplates = html.querySelector('#testTemplates')

	const interval = setInterval(() => {
		if (val === 0) {
			val += 8
		} else {
			val += Math.round(Math.random() * 10)
			if (val > 10) {
				val = 10
			}
		}

		if (val >= 90) {
			val += 1
		} else if (val >= 98) {
			clearInterval(interval)
			return
		}

		setProgress(progress, val)
	}, 500)

	setTimeout(() => {
		const runUrl = messagesGenerating.dataset.runUrl
		naja.makeRequest('GET', runUrl, null, {history: false}).then((payload) => {
			clearInterval(interval)
			if (payload.success) {
				setProgress(progress, 100)
				setTimeout(() => {
					messagesGenerating.classList.add('d-none')
					tester.classList.remove('d-none')
					publish.classList.remove('d-none')
					testTemplates.classList.remove('d-none')
				}, 2000)
			} else {
				if (payload.error) {
					setAlert(html, payload.message)
				}
				setProgress(progress, 100, payload.error)
			}
		}).catch((err) => {
			alert(err)
		})
	}, 1000)
}

function setProgress(progress, val, err) {
	progress.setAttribute('aria-valuenow', val)
	const bar = progress.querySelector('.progress-bar')

	bar.style.width = val + '%'
	if (val === 100) {
		bar.classList.remove('progress-bar-striped')
		if (err) {
			bar.classList.add('bg-danger')
			bar.innerHTML = '<div><i class="fas fa-exclamation-triangle me-2"></i>' + err + '</div>'
		} else {
			bar.classList.add('bg-success')
			bar.innerText = '100%'
		}
	}
}


function setAlert(html, message) {
	const alert = html.querySelector('#generatorErrorMessage')
	alert.classList.remove('d-none')
	alert.innerHTML = '<div><i class="fas fa-exclamation-triangle me-2"></i>' + message + '</div>'
}
